import axios from "axios";
import store from '@/store/index';


axios.defaults.withCredentials = true;

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const apiPassword = process.env.VUE_APP_API_PASSWORD;
    const language = localStorage.getItem("lang") || "en";

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.data = {
      ...config.data,
      apiPassword,
      language,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response.data.errNum === 401) {
      await store.dispatch("auth/logout");
      window.location.href = "/login";

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default apiClient;